import React, { useCallback, useEffect, useReducer, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Typography, Button, Row, InputNumber, Form, Input, Modal, Space } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import moment from 'moment';

import { PatternCodeType } from 'components/Admin/PatternCode';
import {
  SmartSpace,
  SmartFormLabel,
  GreenColor,
  SmartRow,
  SmartScanner,
  SmartBackButton,
  SmartSpin,
} from 'components/Sales/Smart/SmartComponent';
import { message, SetDefaultWarehouseDialog } from 'components/common';
import { LS_DEFAULT_WAREHOUSE_KEY } from 'constants/config';
import { RootState } from 'reducers';
import { queryLocationsByKeyword } from 'services/warehouse';
import {
  fetchWarehouseProductList,
  moveProductLocationToLocation,
} from 'services/inventory';
import {
  getProfileSettingValue,
  getWarehouseIdFromCache,
  playAudio,
  getWarehouseCodeFromCache,
} from 'utils';

import {
  //DefaultScanRecvRatio,
  //defaultUom,
  //ScanRecvCountType,
  //ScanRecvLotPolicy,
  //ScanRecvRatioType,
  PoRecvActionType as PRAction,
  //PoRecvStep,
  initialState,
  //isValidStep,
  reducer,
} from '../GuidedMove2/context';
import {
  clearMatchedPatternList,
  extractPatternCodeList,
  getMatchedPatternCode,
  isAnyPatternMatched,
  isPatternCodeEnabled,
} from '../../PoReceive';
import PatternCodeSelector from '../../PoReceive/PatternCodeSelector';
import FinishDialog from './Finish';

const { Text } = Typography;

const getStateFromStorage = () => {
  const state: StringKAnyVPair = {};
  //const storage = getStorage('session');

  /*
  const scanRecvCountType = storage.getItem(PoRecvStorageKey.ScanRecvCountType);
  if (scanRecvCountType !== null && !isNaN(Number(scanRecvCountType))) state.scanRecvCountType = Number(scanRecvCountType);
  const scanRecvLotPolicy = storage.getItem(PoRecvStorageKey.ScanRecvLotPolicy);
  if (scanRecvLotPolicy !== null && !isNaN(Number(scanRecvLotPolicy))) state.scanRecvLotPolicy = Number(scanRecvLotPolicy);
  const scanRecvLotUniNum = storage.getItem(PoRecvStorageKey.ScanRecvLotUniNum);
  if (scanRecvLotUniNum !== null) state.scanRecvLotUniNum = scanRecvLotUniNum;
  const scanRecvRatio = storage.getItem(PoRecvStorageKey.ScanRecvRatio);
  if (scanRecvRatio !== null && !isNaN(Number(scanRecvRatio))) state.scanRecvRatio = Number(scanRecvRatio);
  const scanRecvRatioType = storage.getItem(PoRecvStorageKey.ScanRecvRatioType);
  if (scanRecvRatioType !== null && !isNaN(Number(scanRecvRatioType))) state.scanRecvRatioType = Number(scanRecvRatioType);
  */

  return state;
};

export default function ReturnToLocation(): JSX.Element {
  const history = useHistory();
  const whs = useSelector(
    (state: RootState) => state.admin.warehouses,
    shallowEqual
  );
  const { t } = useTranslation();
  const [defaultWarehouseVisible, setDefaultWarehouseVisible] =
    React.useState(false);
  const [dialogClosable, setDialogClosable] = React.useState(true);
  const [fetching, setFetching] = useState(false);
  // const [locations, setLocations] = useState<WarehouseLocationRow[]>([]);
  const [finishDialogVisible, setFinishDialogVisible] = useState(false);
  const [inited, setInited] = useState(false);
  const [inputValue, setInputValue] = useState<string>('');
  const [patternCodeSelectorVisible, setPatternCodeSelectorVisible] = useState(false);
  const [productLocations, setProductLocations] = useState<any[]>([]);
  const [qty, setQty] = useState<number>(0);
  const [step, setStep] = useState<string>('sourceLocation'); //'sourceLocation' | 'targetLocation' | 'scanItem' | 'scanQty'
  const [sLocation, setSLocation] = useState<WarehouseLocationRow>();
  const [scanTime, setScanTime] = useState<string>('');
  // const [showUsePick, setShowUsePick] = useState(false);
  const [tLocation, setTLocation] = useState<WarehouseLocationRow>();
  const [warehouseNum, setWarehouseNum] = useState<number>(-1);
  const [warehouseId, setWarehouseId] = useState<string>('');

  const [state, dispatch] = useReducer(reducer, initialState(getStateFromStorage()));

  // eslint-disable-next-line
  const checkEnv = async () => {
    const res3 = await getProfileSettingValue('EnableMultiPurpostProductCode', '0');

    dispatch({ type: PRAction.SetEnableMultiPurposeCode, params: res3 === '1' });
    (res3 === '1') && openPatternCodeSelector();
  };

  const openSetDefaultWarehouseDialog = (config: StringKAnyVPair) => {
    setDialogClosable(
      typeof config.closable === 'boolean' ? config.closable : true
    );
    setDefaultWarehouseVisible(true);
  };

  React.useEffect(() => {
    if (
      !localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY) ||
      !getWarehouseCodeFromCache(
        Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY))
      )
    ) {
      openSetDefaultWarehouseDialog({ closable: false });
    }
  }, []);

  React.useEffect(() => {
    if (!inited) {
      checkEnv();
      setInited(true);
    }

    if (whs) {
      const exist = whs.filter(
        (e) =>
          e.id === Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY)) &&
          (e.warehouseType === 1 || e.warehouseType === 5)
      );
      if (exist.length === 0) {
        openSetDefaultWarehouseDialog({ closable: false });
      }
    }
  }, [checkEnv, inited, whs]);

  useEffect(() => {
    if (localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY)) {
      setWarehouseNum(Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY)));
      setWarehouseId(
        getWarehouseIdFromCache(
          Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY))
        )
      );
    }
  }, []);

  const closePatternCodeSelector = () => {
    setPatternCodeSelectorVisible(false);
  };

  const handleKeyDown = async (evt: any) => {
    if ([9, 13].indexOf(evt.keyCode) > -1) {
      setInputValue('');
      evt.preventDefault();
      if (evt.target.value) {
        if (
          evt.target.value === productLocations[0].sku ||
          evt.target.value === productLocations[0].upc
        ) {
          playAudio('success');
          setQty((prev) => prev + 1);
          setScanTime(moment().format('hh:mm:ssA'));
        } else {
          playAudio('error');
          message.info({ content: 'not match item' });
        }
      }
    }
  };

  const onClosePatternCodeSelectorWithoutSelection = () => {
    //tryOpenDefaultLocationDialogWithoutPatternCode();
  };

  const onSelectPatternCode = (pat: StringKAnyVPair) => {
    /*
    const location = (pat.items || []).find((p: StringKAnyVPair) => p.valueType === PatternCodeType.Location);
    //console.log('p', location);
    !location && openDefaultLocationDialog();
    */
  };

  const openPatternCodeSelector = () => {
    setPatternCodeSelectorVisible(true);
  };

  const moveProduct = useCallback(async () => {
    try {
      setFetching(true);
      const res = await moveProductLocationToLocation({
        fromWarehouse: warehouseId,
        fromLocation: sLocation?.locationNum || -1,
        fulfillmentProductNum: productLocations[0].fulfillmentProductNum,
        quantity: qty,
        toWarehouse: warehouseNum,
        toLocation: tLocation?.locationNum || -1,
      });
      setFetching(false);
      if (res) {
        setFinishDialogVisible(true);
        // message.success({ content: 'Move successfully' });
      }
    } catch (error) {
      setFetching(false);
    }
  }, [sLocation, tLocation, warehouseId, productLocations, qty, warehouseNum]);

  const fetchProductsByLocationCode = async (sk: string) => {
    let code = sk.trim();

    if (isPatternCodeEnabled(state)) {
      const pl = extractPatternCodeList(state, sk);
      const patternMatched = isAnyPatternMatched(pl || []);

      if (pl && patternMatched && getMatchedPatternCode(pl, PatternCodeType.SKU)) {
        const codeList: StringKAnyVPair[] = [];
        const pQty = getMatchedPatternCode(pl, PatternCodeType.Qty);

        (pl || []).forEach(e => codeList.push(e));
        dispatch({ type: PRAction.SetMatchedPatternList, params: codeList });
        code = getMatchedPatternCode(pl, PatternCodeType.SKU);
        //setInputValue(code);
        (!isNaN(Number(pQty))) && setQty(pQty);
      }
      //console.log('pm', patternMatched, pl);
    }

    try {
      const query = {
        $skip: 0,
        $top: 10000,
        $sortBy: 'locationCode',
        $calculateTotal: true,
        $count: true,
        uniqueCode: code,
      };
      setFetching(true);
      const res = await fetchWarehouseProductList(warehouseId, query);
      setFetching(false);
      if (res.data.length > 0) {
        const temp = res.data.filter(
          (item: any) => item.locationCode === sLocation?.locationCode
        );
        if (temp.length > 0) {
          setProductLocations(
            res.data.filter((item: any) => item.locationCode !== 'Checkout')
          );
          setStep('targetLocation');
        } else {
          message.error({
            content: `not found Item from '${sLocation?.locationCode}'`,
          });
        }
      } else {
        message.error({ content: 'not found Item' });
      }
    } catch (error) {
      setFetching(false);
    }
  };

  const queryLocation = useCallback(
    async (value: string, step: string, callback: (value: any) => void) => {
      try {
        setFetching(true);
        const res = await queryLocationsByKeyword(warehouseId, value, true);
        setFetching(false);

        if (!res.error) {
          callback(res);
          if (step.length > 0) {
            setStep(step);
          }
        }
      } catch (error) {
        setFetching(false);
      }
    },
    [warehouseId]
  );

  // const getLocations = useCallback(async () => {
  //   try {
  //     setFetching(true);
  //     const res = await fetchWarehouseLocationList(warehouseId, true);
  //     setFetching(false);
  //     setLocations(res);
  //   } catch (error) {
  //     setFetching(false);
  //   }
  // }, [warehouseId]);

  /* eslint-disable */
  // useEffect(() => {
  //   if (warehouseId && locations.length === 0) {
  //     getLocations();
  //   }
  // }, [warehouseId]);
  /* eslint-enable */

  return (
    <div style={{ marginTop: 20 }}>
      {step === 'sourceLocation' && (
        <>
          <SmartSpin loading={fetching} />
          <SmartSpace>
            <SmartFormLabel
              style={{ color: GreenColor, fontWeight: 600, fontSize: 18 }}
            >
              {t("smart.movemerge.scanSourceLocationtoStart")}
            </SmartFormLabel>
            <SmartScanner
              style={{ marginTop: 10 }}
              onChangeValue={(value) => {
                queryLocation(value, 'scanItem', setSLocation);

                // const temp = locations.filter((i) => i.code === value);
                // if (temp.length > 0) {
                //   setSLocation(temp[0]);
                //   setStep('scanItem');
                // } else {
                //   message.error('No matching location');
                // }
              }}
            />
          </SmartSpace>
          {/* <SmartRow justify="space-between">
            <Button
              type="text"
              onClick={() => {
                queryLocation('General', 'scanItem', setSLocation);
                // const temp = locations.filter((i) => i.code === 'General');
                // if (temp.length > 0) {
                //   setSLocation(temp[0]);
                //   setStep('scanItem');
                // } else {
                //   message.error('No matching location [General]');
                // }
              }}
            >
              Use General
            </Button>
            <Button type="text" onClick={() => setShowUsePick((prev) => !prev)}>
              ...
            </Button>
          </SmartRow> */}
          <Row style={{ marginTop: 10 }}>
            <Space>
              <Button
                type="primary"
                onClick={() => {
                  queryLocation('Pick', 'scanItem', setSLocation);
                }}
              >
                Use Pick
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  queryLocation('General', 'scanItem', setSLocation);
                }}
              >
                Use General
              </Button>
            </Space>
          </Row>

          {/* <Row justify="center" style={{ height: 100, alignItems: 'center' }}>
            {showUsePick && (
              <Button
                type="primary"
                onClick={() => {
                  queryLocation('Pick', 'scanItem', setSLocation);

                  // const temp = locations.filter((i) => i.code === 'Pick');
                  // if (temp.length > 0) {
                  //   setSLocation(temp[0]);
                  //   setStep('scanItem');
                  // } else {
                  //   message.error('No matching location [Pick]');
                  // }
                }}
              >
                Use Pick
              </Button>
            )}
          </Row> */}

          <SmartBackButton
            onClick={() => {
              history.goBack();
            }}
          />
        </>
      )}

      {step === 'scanItem' && (
        <>
          <SmartSpin loading={fetching} />
          <SmartRow>
            <SmartFormLabel>
              {t("smart.movemerge.from")}
            </SmartFormLabel>
            <Text strong style={{ marginLeft: 4, fontSize: 18 }}>
              {sLocation?.locationCode}
            </Text>
          </SmartRow>
          <SmartSpace>
            <SmartFormLabel
              style={{ color: GreenColor, fontWeight: 600, fontSize: 18 }}
            >
              {t("smart.movemerge.scanItem")}
            </SmartFormLabel>
            <SmartScanner
              style={{ marginTop: 10, marginBottom: 8 }}
              onChangeValue={(value) => fetchProductsByLocationCode(value)}
            />
          </SmartSpace>
          <SmartBackButton
            onClick={() => {
              setStep('sourceLocation');
            }}
          />
        </>
      )}
      {step === 'targetLocation' && (
        <>
          <SmartSpin loading={fetching} />
          <SmartRow>
            <SmartFormLabel>
              {t("smart.movemerge.from")}
            </SmartFormLabel>
            <Text strong style={{ marginLeft: 4, fontSize: 18 }}>
              {sLocation?.locationCode}
            </Text>
          </SmartRow>
          <SmartRow justify="space-between">
            <Text>
              {t("common.sku")}:
              <Text strong style={{ marginLeft: 4, fontSize: 18 }}>
                {productLocations[0]?.sku}
              </Text>
            </Text>

            <Text>
              {t("common.upc")}:
              <Text strong style={{ marginLeft: 4, fontSize: 18 }}>
                {productLocations[0]?.upc}
              </Text>
            </Text>
          </SmartRow>
          <SmartSpace>
            <SmartFormLabel
              style={{ color: GreenColor, fontWeight: 600, fontSize: 18 }}
            >
              {t("smart.movemerge.scanLocation")}
            </SmartFormLabel>
            <SmartScanner
              style={{ marginTop: 10 }}
              onChangeValue={(value) => {
                if (value === sLocation?.locationCode) {
                  return message.error('Cannot use the same location');
                } else {
                  const temp1 = productLocations.filter(
                    (j) => j.locationCode === value && j.quantity > 0
                  );
                  if (temp1.length > 0) {
                    queryLocation(value, 'scanQty', setTLocation);
                  } else {
                    Modal.confirm({
                      title: 'Are you sure to continue？',
                      icon: <ExclamationCircleOutlined />,
                      content: (
                        <Text>
                          Scanned location [<Text type="danger">{value}</Text>]
                          didn't have record of this item [
                          <Text type="danger">{productLocations[0]?.sku}</Text>]
                        </Text>
                      ),
                      okText: 'Yes',
                      onOk() {
                        queryLocation(value, 'scanQty', setTLocation);
                      },
                      onCancel() {
                        return;
                      },
                    });
                  }
                }
              }}
            />
          </SmartSpace>
          <SmartRow>
            <Text strong style={{ fontSize: 16 }}>
              {t("common.location")}:
            </Text>
          </SmartRow>
          <div
            style={{
              paddingLeft: 8,
              paddingRight: 8,
              marginBottom: 8,
              width: '100%',
            }}
          >
            {productLocations
              .filter((i) => i.quantity > 0)
              .map((item: any) => (
                <Text
                  key={item.locationCode}
                  style={{
                    fontSize: 16,
                    marginRight: 6,
                  }}
                >
                  <Text strong>{item.locationCode}</Text>
                  {`(${item.quantity})`}
                </Text>
              ))}
          </div>
          <SmartBackButton
            onClick={() => {
              setStep('scanItem');
            }}
          />
        </>
      )}
      {step === 'scanQty' && (
        <>
          <SmartSpin loading={fetching} />
          <SmartRow justify="space-between">
            <Text>
              {t("smart.movemerge.from")}:
              <Text strong style={{ marginLeft: 4, fontSize: 18 }}>
                {sLocation?.locationCode}
              </Text>
            </Text>

            <Text>
              {t("smart.movemerge.to")}:
              <Text strong style={{ marginLeft: 4, fontSize: 18 }}>
                {tLocation?.locationCode}
              </Text>
            </Text>
          </SmartRow>
          <SmartRow justify="space-between">
            <Text>
              {t("common.sku")}:
              <Text strong style={{ marginLeft: 4, fontSize: 18 }}>
                {productLocations[0]?.sku}
              </Text>
            </Text>

            <Text>
              {t("common.upc")}:
              <Text strong style={{ marginLeft: 4, fontSize: 18 }}>
                {productLocations[0]?.upc}
              </Text>
            </Text>
          </SmartRow>
          <SmartRow>
            <Form.Item
              label={
                <Text
                  style={{
                    fontSize: 18,
                    color: 'rgb(86, 149, 34)',
                    fontWeight: 600,
                  }}
                >
                  {t("smart.movemerge.scanItem")}:
                </Text>
              }
            >
              <Input
                autoFocus
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                style={{ marginLeft: 8 }}
                onKeyDown={handleKeyDown}
              />
            </Form.Item>
          </SmartRow>
          <SmartRow justify="space-between" style={{ alignItems: 'start' }}>
            <Form.Item
              label={
                <Text
                  style={{
                    fontSize: 18,
                    color: 'rgb(86, 149, 34)',
                    fontWeight: 600,
                  }}
                >
                  {t("common.qty")}:
                </Text>
              }
            >
              <InputNumber
                min={0}
                value={qty}
                style={{ marginLeft: 8 }}
                onChange={(value) => setQty(value)}
              />
            </Form.Item>
            <Button type="primary" onClick={() => moveProduct()}>
              {t("common.confirm")}
            </Button>
          </SmartRow>
          <SmartRow>
            <Text>
              {/* Last scan at: <Text>{scanTime}</Text> */}
              {t("smart.movemerge.lastScanAt", { value: scanTime })}
              :
            </Text>
          </SmartRow>
          <SmartRow>
            <Text strong style={{ fontSize: 16 }}>
              {t("common.location")}
              :
            </Text>
          </SmartRow>
          <div
            style={{
              paddingLeft: 8,
              paddingRight: 8,
              marginBottom: 8,
              width: '100%',
            }}
          >
            {productLocations
              .filter((i) => i.quantity > 0)
              .map((item: any) => (
                <Text
                  key={item.locationCode}
                  style={{
                    fontSize: 16,
                    marginRight: 6,
                  }}
                >
                  <Text strong>{item.locationCode}</Text>
                  {`(${item.quantity})`}
                </Text>
              ))}
          </div>

          <SmartBackButton
            onClick={() => {
              setStep('targetLocation');
            }}
          />
        </>
      )}
      {finishDialogVisible && tLocation && sLocation && (
        <FinishDialog
          tLocation={tLocation.locationCode || ''}
          sLocation={sLocation.locationCode || ''}
          sku={productLocations[0].sku}
          upc={productLocations[0].upc}
          qty={qty}
          onSubmit={(value) => {
            setFinishDialogVisible(false);
            if (value === 'home') {
              history.push('/smart');
            }
            if (value === 'sourceLocation') {
              setSLocation(undefined);
              setTLocation(undefined);
              setInputValue('');
              setQty(0);
              setScanTime('');
              setStep('sourceLocation');
              isPatternCodeEnabled(state) && clearMatchedPatternList(dispatch);
            }
            if (value === 'item') {
              setTLocation(undefined);
              setInputValue('');
              setQty(0);
              setScanTime('');
              setStep('scanItem');
              isPatternCodeEnabled(state) && clearMatchedPatternList(dispatch);
            }
          }}
        />
      )}
      {patternCodeSelectorVisible && (
        <PatternCodeSelector
          dispatch={dispatch}
          maskClosable={false}
          onCancel={closePatternCodeSelector}
          onClosePatternCodeSelectorWithoutSelection={onClosePatternCodeSelectorWithoutSelection}
          onSelectPatternCode={onSelectPatternCode}
          state={state}
          title="Select Pattern Code"
          visible={patternCodeSelectorVisible}
        />
      )}
      {
        <SetDefaultWarehouseDialog
          closable={dialogClosable}
          close={() => {
            setDefaultWarehouseVisible(false);
          }}
          visible={defaultWarehouseVisible}
        />
      }
    </div>
  );
}
